import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Creatable } from 'react-select';

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })),
  currentCategory: PropTypes.string,
  onCategoryChange: PropTypes.func.isRequired,
};

const defaultProps = {
  categories: [],
  currentCategory: undefined,
};

// https://github.com/JedWatson/react-select/tree/v1.3.0#creatable-properties
const promptTextCreator = label => `Add category "${label}"`;

const newOptionCreator = ({ label, ...rest }) => ({
  label: label.toUpperCase(),
  ...rest,
});

const createCategoryOption = category => ({
  label: category,
  value: category,
});

const BlogCategoryDropdown = ({
  categories,
  currentCategory,
  onCategoryChange,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    currentCategory ? createCategoryOption(currentCategory) : null,
  );

  const options = categories.map(({ name }) => createCategoryOption(name));

  const onChange = (option) => {
    setSelectedOption(option);
    onCategoryChange(option?.label);
  };

  return (
    <Creatable
      newOptionCreator={newOptionCreator}
      onChange={onChange}
      options={options}
      placeholder="Select an existing category or create a new one..."
      promptTextCreator={promptTextCreator}
      resetValue={null}
      value={selectedOption}
    />
  );
};

BlogCategoryDropdown.propTypes = propTypes;
BlogCategoryDropdown.defaultProps = defaultProps;

BlogCategoryDropdown.fragments = {
  blogCategory: gql`
    fragment BlogCategoryDropdownBlogCategory on BlogCategory {
      name
    }
  `,
};

export default BlogCategoryDropdown;
